import { useAuth } from "./useAuth";

export const useAuthPermissions = (module: string) => {
  const { profile } = useAuth();
  const permissions: string[] =
    profile && Array.isArray(profile.permissions) ? profile.permissions : [];
  const userPermissions = permissions.filter((permission: string) =>
    permission.includes(module)
  );

  return {
    canEdit: userPermissions.some((permission: string) =>
      permission.includes("update")
    ),
    canDelete: userPermissions.some((permission: string) =>
      permission.includes("delete")
    ),
    canCreate: userPermissions.some((permission: string) =>
      permission.includes("create")
    ),
    canView: userPermissions.some((permission: string) =>
      permission.includes("view")
    ),
    userPermissions,
  };
};
